import { collection, deleteDoc, doc, getDoc, getDocs, query, updateDoc, where } from "firebase/firestore";
import axiosInstance from "../axios";
import { BaseUrl, COLLECTIONS, DOMAINURL } from '../config';
import { getLoginToken } from '../storage';
import { firebase } from "../firebase-config";
import { getAuth, updateEmail } from "firebase/auth";
import moment from "moment";

/**
 * HELPER: Send email with plan validation via backend
 * Ensures companyId is always included for FREEMIUM plan blocking
 */
export async function sendEmailWithValidation(to, subject, contenttxt, companyId, options = {}) {
  try {
    const toAddress = Array.isArray(to)
      ? to.filter(Boolean).map((e) => (typeof e === "string" ? e.trim() : "")).filter(Boolean).join(", ")
      : (typeof to === "string" ? to.trim() : "");
    
    if (!toAddress) {
      return { success: false, status: 400, error: "Recipient email is required" };
    }

    const authHeaders = { Authorization: `Bearer ${getLoginToken()}` };
    const res = await axiosInstance.post(
      `${BaseUrl}sendEmailData`,
      {
        email: toAddress,
        subject,
        contenttxt,
        companyId, // ✅ IMPORTANT: Always include for plan validation
        ...options
      },
      {
        headers: {
          "Content-Type": "application/json",
          withCredentials: true,
          ...authHeaders,
        },
      }
    );

    return { success: res.data.status, data: res.data };
  } catch (error) {
    if (error.response?.status === 403) {
      return { 
        success: false, 
        status: 403, 
        error: error.response?.data?.message || "Email feature not available on your plan"
      };
    }
    console.error('Error sending email:', error);
    return { success: false, status: error.response?.status || 500, error: 'Failed to send email' };
  }
}


export async function sendEmailWithFiles(to, subject, contenttxt, excelUrl, pdfUrl, fullPdfUrl, fullExcelUrl, reportDate, FileName, name, endDate, companyId = null) {
    try {
      const toAddress = Array.isArray(to)
        ? to.filter(Boolean).map((e) => (typeof e === "string" ? e.trim() : "")).filter(Boolean).join(", ")
        : (typeof to === "string" ? to.trim() : "");
      if (!toAddress) {
        return { success: false, status: 400, error: "Require parameter 'to' (recipient email) missing" };
      }
      const updatedSubject = `ProTeams - ${FileName}: ${moment(reportDate).format("MM/DD/YY")} - ${moment(endDate).format("MM/DD/YY")}`;

        const requestBody = {
            to: toAddress,
            subject: updatedSubject,
            companyId,
            contenttxt: contenttxt,
            xlsAttachment: excelUrl,
            pdfAttachment: pdfUrl,
            fullPdfAttachment: fullPdfUrl,
            fullExcelAttachment: fullExcelUrl,
            date: reportDate
        };

        const authHeaders = { Authorization: `Bearer ${getLoginToken()}` };
        const res = await axiosInstance.post(
            `${BaseUrl}sendEmailWithFiles`,
            requestBody,
            {
                headers: {
                    "Content-Type": "application/json",
                    withCredentials: true,
                    ...authHeaders,
                },
            }
        );

        return { success: true, status: res.status, data: res.data };

    } catch (error) {
        console.error('Error sending email:', error);
        return { success: false, status: error.response?.status || 500, error: 'Failed' };
    }
}


export async function sendRegisterEmail(
  email,
  onSuccess,
  onError,
  uidHint = null
) {
  try {
    const normalizedEmail =
      typeof email === "string" ? email.trim().toLowerCase() : "";
    const normalizedUid = uidHint != null ? String(uidHint).trim() : "";
    if (!normalizedEmail && !normalizedUid) {
      throw new Error("Recipient email or user id is required for sendRegisterEmail");
    }

    const response = await axiosInstance.post(`${BaseUrl}completeEmailVerification`, {
      email: normalizedEmail || undefined,
      uid: normalizedUid || undefined,
    });

    onSuccess &&
      onSuccess({
        status: Boolean(response?.data?.status),
        data: response?.data?.data || [],
      });
  } catch (error) {
    console.error("sendRegisterEmail error:", error);
    onError && onError({ status: false, error });
  }
}

export async function handleEmployeeEmailChange(oldEmail, newEmail, displayName, userId) {
  try {
    const authHeaders = { Authorization: `Bearer ${getLoginToken()}` };
    await axiosInstance.post(`${BaseUrl}employeeEmailVerifyLink`, {
      oldEmail,
      newEmail,
      displayName,
      userId,
    }, { headers: { "Content-Type": "application/json", withCredentials: true, ...authHeaders } });
  } catch (error) {
    console.error("Error sending verification link:", error);
  }
}

// export async function sendEmailForManulallyVerify() {
//   try {
//     const authHeaders = { Authorization: `Bearer ${getLoginToken()}` };
//     const email = "teprummiqueureu-2943@yopmail.com";
//     await axiosInstance.post(`${BaseUrl}sendManualVerificationEmail`, {
//       email
//     }, { headers: { "Content-Type": "application/json", withCredentials: true, ...authHeaders } });
//   } catch (error) {
//     console.error("Error sending verification link:", error);
//   }
// }

export async function handleEmailChange(oldEmail, newEmail, displayName, userId) {
  try {
    const authHeaders = { Authorization: `Bearer ${getLoginToken()}` };
    await axiosInstance.post(`${BaseUrl}emailVerifyLink`, {
      oldEmail,
      newEmail,
      displayName,
      userId,
    }, { headers: { "Content-Type": "application/json", withCredentials: true, ...authHeaders } });
  } catch (error) {
    console.error("Error sending verification link:", error);
  }
}

export async function handleEmailChangeSuperUser(oldEmail, newEmail, displayName, userId) {
  try {
    const authHeaders = { Authorization: `Bearer ${getLoginToken()}` };
    await axiosInstance.post(`${BaseUrl}updateEmailVerifyLink`, {
      oldEmail,
      newEmail,
      displayName,
      userId,
    }, { headers: { "Content-Type": "application/json", withCredentials: true, ...authHeaders } });
  } catch (error) {
    console.error("Error sending verification link:", error);
  }
}

export async function resendOtp(email, name, userId, superUserRequest) {
  try {
    const otp = Math.floor(100000 + Math.random() * 900000);

    const userRef = doc(firebase, COLLECTIONS.USERS, userId);
    await updateDoc(userRef, { emailChangeOtp: otp, superUserRequest: superUserRequest });

    const htmlContent = `
      <div style="font-family: Arial, sans-serif; color: #333; max-width: 600px; margin: 0 auto; background-color: #ffffff; border-radius: 10px; overflow: hidden;">
            <div style="background-color:#f4f6f8; padding:20px; text-align:center;">
              <img
                src="https://${DOMAINURL}/csmGrayTextLogin.png"
                alt="ProTeams Logo"
                width="180"
                style="display:block; margin:0 auto; max-width:180px; width:100%; height:auto; border:0;"
              />
            </div>

            <div style="padding:25px 20px;">

        <p style="font-size: 16px;">Hi <strong>${name}</strong>,</p>
        <p>Your <strong>6-digit</strong> verification code is: 
          <span style="font-size: 20px; font-weight: bold; color: #2980ba;">${otp}</span>
        </p>
        <p>This code is valid for 5 minutes.</p>

        <hr style="border:none; border-top:1px solid #e5e7eb; margin:30px 0;">

              <p style="text-align:center; font-size:13px; color:#666; margin:0;">
                For assistance, feel free to <a href="https://${DOMAINURL}/help/support" style="color:#1a73e8; text-decoration:underline;">contact support</a>.<br>
                © ${new Date().getFullYear()} ProTeams. All rights reserved.
              </p>
      </div>
      </div>
    `;

    const authHeaders = { Authorization: `Bearer ${getLoginToken()}` };

    axiosInstance.post(
      `${BaseUrl}sendEmailData`,
      {
        companyId: userId,
        email,
        subject: "Your Email Change Verification Code",
        contenttxt: htmlContent,
      },
      {
        headers: {
        "Content-Type": "application/json",
         withCredentials: true,
         ...authHeaders,
        },
      });

    return { success: true, message: "OTP generated and sending email in background" };
  } catch (error) {
    console.error("Error in resendOtp:", error);
    return { success: false, message: error.message || "Failed to generate OTP" };
  }
}


export async function updateUserEmail(newEmail) {
  try {
    const authHeaders = { Authorization: `Bearer ${getLoginToken()}` };
    await axiosInstance.post(
      `${BaseUrl}syncEmailToFirestore`,
      {
        newEmail
      },
      { 
        headers: { 
          "Content-Type": "application/json", 
          withCredentials: true,
          ...authHeaders 
        }, 
      }
    );
    console.log("User email synced successfully");
  } catch (error) {
    console.error("Error syncing user email:", error);
  }
}

export async function finalizeEmailUpdate() {
  const auth = getAuth();
  await auth.currentUser?.reload();

  try {
    const userRef = doc(firebase, COLLECTIONS.USERS, auth.currentUser?.uid);

    const userSnap = await getDoc(userRef);
    const userData = userSnap.data();

    if (!userData?.pendingEmail) {
      console.warn("No pendingEmail to update");
      return;
    }

    const newEmail = userData.pendingEmail;

    await updateDoc(userRef, {
      email: newEmail,
      pendingEmail: null,
    });

    if (auth.currentUser) {
      try {
        await updateEmail(auth.currentUser, newEmail);
        console.log("Auth email updated successfully");
      } catch (err) {
        console.warn("Failed to update Auth email:", err);
      }
    }

    console.log("Email update finalized successfully.");

  } catch (error) {
    console.error("Error finalizing email update:", error);
  }
}

// const subscriptionId = "sub_1RtRlHHPX5Uwv3eVi72ASEyZ"
// const extraDays = 30

// export async function extendTrial() {
//   try {
//     const subscription = await stripe.subscriptions.retrieve(subscriptionId);

//     if (!subscription.trial_end || subscription.trial_end * 1000 < Date.now()) {
//       console.log('Trial has already ended. Cannot extend.');
//       return;
//     }

//     const newTrialEnd = Math.floor(Date.now() / 1000) + extraDays * 24 * 60 * 60;

//     const updatedSubscription = await stripe.subscriptions.update(subscriptionId, {
//       trial_end: newTrialEnd,
//     });

//     const remainingSeconds = updatedSubscription.trial_end - Math.floor(Date.now() / 1000);
//     const remainingDays = Math.ceil(remainingSeconds / (24 * 60 * 60));

//     console.log(`Trial extended successfully! Remaining trial days: ${remainingDays}`);

//     return updatedSubscription;
//   } catch (error) {
//     console.error('Error extending trial:', error.message);
//   }
// }

export async function handleSendEmail(selectedPhotos, to, subject, message){
  try {
    const authHeaders = { Authorization: `Bearer ${getLoginToken()}` };
    const requestBody = {
            to: to,
            subject: subject,
            contenttxt: message,
            photos: selectedPhotos,
        };

    const res = await axiosInstance.post(
        `${BaseUrl}sendTaskProofEmail`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
             withCredentials: true,
             ...authHeaders,
          },
        }
      );
    return { success: true, status: res.status, data: res.data };
  } catch (error) {
    console.error('Error sending email:', error);
    return { success: false, status: error.response?.status || 500, error: 'Failed' }; 
  }
};
